import React from 'react'
import { FamilyProgramBody } from '../FamilyProgram/FamilyProgramIndex'
import { GetFamilyNameListEPmbo } from '../../variables/Config' 

class FamilyPostProgramIndex extends React.PureComponent {
    render() {
        return (
            <div>
                <div id="modal-root"></div>
                <FamilyProgramBody mbouser={this.props.mbouser} families={ GetFamilyNameListEPmbo } />
            </div>
        )
    }
}
export default FamilyPostProgramIndex;
